<template>
  <table class="table">
    <template
      v-for="(field, index) in giftCardFields"
      :key="index"
    >
      <tr
        v-if="props.item?.[field.name]"
        class="gift-card-field"
      >
        <th class="gift-card-label">
          {{ $t(field.label) }}:
        </th>
        <td>{{ props.item?.[field.name] }}</td>
      </tr>
    </template>
  </table>
</template>

<script setup lang="ts">
import type { MagentoCartItem } from '~layers/app/types/magento'

export interface Props {
  item: MagentoCartItem
}
const props = defineProps<Props>()

const giftCardFields = [
  { label: 'Recipient Email', name: 'recipient_email' },
  { label: 'Recipient Name', name: 'recipient_name' },
  { label: 'Sender Email', name: 'sender_email' },
  { label: 'Sender Name', name: 'sender_name' },
  { label: 'Message', name: 'message' },
]
</script>
